import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  table: {
    border: '1px solid #EAECED',
    display: 'flex',
    marginBottom: '15px',
    padding: '15px'
  }
});

export const Table = (props: any) => {
  return (
    <View style={styles.table}>
      {props.children}
    </View>
  )
};

export default Table;
